// X-08: label for a player's active suspensions — "Inhabilitado" for a Tribunal blacklist,
// otherwise the largest number of matches still to serve.
export const suspensionChipLabel = (intl, suspensions = []) => {
  if (suspensions.some((suspension) => suspension?.blacklist)) {
    return intl.formatMessage({ id: "league.planillero.suspension.banned" });
  }
  const remaining = Math.max(0, ...suspensions.map((suspension) => Number(suspension?.remaining_matches) || 0));
  return intl.formatMessage({ id: "league.planillero.suspension.chip" }, { count: remaining });
};

export const suspensionTooltip = (suspensions = []) =>
  suspensions.map((suspension) => suspension?.comments).filter(Boolean).join(" · ");
